module.exports = __webpack_public_path__ + "static/screen-2-031be52ff2f6dd1b24c894b9233d9837.png";